export default __webpack_public_path__ + "static/team2-abe5b11f18d59586409d0b3c224f41a7.png";